import { createStorage } from '@/shared/storage';

const TAB_ID_KEY = 'agenthub:chat-view:tab-id';
const WINDOW_ID_KEY = 'agenthub:chat-view:window-id';

const sessionStorageSafe = createStorage('session');

function makeId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}

export function getTabId(): string {
  const existing = sessionStorageSafe.get<string>(TAB_ID_KEY, '');
  if (existing) return existing;
  const next = makeId();
  sessionStorageSafe.set(TAB_ID_KEY, next);
  return next;
}

export function getWindowId(): string {
  if (typeof window === 'undefined') return 'server';
  const currentName = window.name.trim();
  if (currentName) return currentName;
  const next = sessionStorageSafe.get<string>(WINDOW_ID_KEY, '') || makeId();
  sessionStorageSafe.set(WINDOW_ID_KEY, next);
  window.name = next;
  return next;
}
